export const ROUTES = {
  CASE_DISCUSSIONS: "/case-discussions",
};

export const CASE_DISCUSSIONS_ROUTES = {
  LIST:   "/case-discussions",
  DETAIL: (id = ":id") => `/case-discussions/${id}`,
  LIVE:   (id = ":id") => `/case-discussions/${id}/live`,
};